import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CombinedReadonlyDirective } from '../../../../../../../directives/combined-readonly.directive';
import { ActivityEditDialogData, ActivityTrainTicket } from '../../../../../../../models';
import { InputMonetaryAmountComponent } from '../../../../../../shared/input-monetary-amount/input-monetary-amount.component';
import { InputTimeComponent } from '../../../../../../shared/input-time/input-time.component';
import { TRAIN_TICKET_DISCLAIMER_TEXT } from '../../../../../../shared/utils';
import { ActivityEditDialogBase } from '../../activity-edit-dialog-base';

@Component({
  selector: 'app-train-ticket-edit-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    DragDropModule,
    TranslateModule,
    InputTimeComponent,
    InputMonetaryAmountComponent,
    CombinedReadonlyDirective
  ],
  templateUrl: './train-ticket-edit-dialog.component.html'
})
export class TrainTicketEditDialogComponent extends ActivityEditDialogBase<ActivityTrainTicket> implements OnInit {

  form!: FormGroup;

  today: Date | null;

  constructor(
    dialogRef: MatDialogRef<TrainTicketEditDialogComponent>,
    confirmationDialog: MatDialog,
    translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) override data: ActivityEditDialogData
  ) {
    super(dialogRef, confirmationDialog, translateService, data);
    this.today = new Date();
  }
  ngOnInit(): void {

    this.initForm();

    // ABBIAMO DECISO IL 19/10/2025 CHE LA DATA DI PAGAMENTO VIENE INSERITA NELLA DIALOG DAL TD
    // E VIENE IMPOSTATA COME DATA MINIMA LA DATA ODIERNA 
    // la data di acquisto anticipato ha come limite massimo la start date
    // e viene prevalorizzata 30 gg prima di essa
    // const defaultadvancePurchaseDays = new Date(this.today!);
    // defaultadvancePurchaseDays.setDate(defaultadvancePurchaseDays.getDate() - 30);
    // this.form.get('advancePurchaseDays')?.setValue(defaultadvancePurchaseDays);

    if (this.data.activityData) {
      this.fillFormFields(this.data.activityData as ActivityTrainTicket);
    }

  }

  initForm(): void {
    this.form = new FormGroup({
      departureStation: new FormControl('', [Validators.required, Validators.maxLength(30)]),
      arrivalStation: new FormControl('', [Validators.required, Validators.maxLength(30)]),
      startTime: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required]),
      totalPrice: new FormControl(0, [Validators.required, Validators.min(0)]),
      advancePurchaseDays: new FormControl('', [Validators.required]),
      trainNumber: new FormControl(''),
      carriage: new FormControl(''),
      seatNumber: new FormControl(''),
      notes: new FormControl(''),
      disclaimer: new FormControl(TRAIN_TICKET_DISCLAIMER_TEXT),
      name: new FormControl('Train Ticket'),
      type: new FormControl('train-ticket'),
    });
  }

  private fillFormFields(data: ActivityTrainTicket): void {
    this.form.patchValue({
      departureStation: data.departureStation,
      arrivalStation: data.arrivalStation,
      startTime: data.startTime,
      endTime: data.endTime,
      totalPrice: data.totalPrice,
      advancePurchaseDays: data.advancePurchaseDays,
      trainNumber: data.trainNumber,
      carriage: data.carriage,
      seatNumber: data.seatNumber,
      name: data.name,
      disclaimer: data.disclaimer,
      notes: data.notes
    })

  }

  confirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.confirmAndCloseDialog(this.form.getRawValue() as ActivityTrainTicket);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  /**
 * Get error message for label field
 */
  getLabelErrorMessage(fieldName: string): string {
    if (this.form.get(fieldName)?.hasError('required')) {
      return "required-field"
    }
    if (this.form.get(fieldName)?.hasError('maxlength')) {
      return "maxlenght-field";
    }
    return '';
  }

}
